import { render, staticRenderFns } from "./Donors.vue?vue&type=template&id=44bf8db9&"
import script from "./Donors.vue?vue&type=script&lang=js&"
export * from "./Donors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports